<template>
  <v-card :class="setClass" @click="selectMarket()">
    <div class="outcome-row">
      <div>{{ outcome.name }}</div>
      <div>{{ percentage }}%</div>
    </div>

    <div class="users-row">
      <UserAvatarList
        :users="outcome.users"
        :avatarSize="16"
        :avatarOverlay="0.5"
      ></UserAvatarList>
    </div>
  </v-card>
</template>

<style scoped>
.v-card {
  background: #ffffff;
  box-shadow: 0px 0px 8px rgba(48, 67, 81, 0.08) !important;
}
.v-card .outcome-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-bottom: none;
}
.v-card .outcome-row:first-child {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 20px;
  color: #6d818f;
}
.v-card .outcome-row div:nth-child(2) {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #bcc5cc;
}
.v-card .users-row {
  background: #f3f6f7;
  padding: 8px 16px;
  border: 1px solid #d8e0e6;
  border-bottom-left-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}
.v-card .users-row >>> .col {
  padding: 0;
}
.v-card >>> .v-ripple__container {
  display: none !important;
}
.v-card.tiro-certeiro .outcome-row.v-card.tiro-certeiro .users-row {
  background-color: #f3f6f7;
  border-top: 1px solid #d8e0e6;
  border-left: 1px solid #d8e0e6;
  border-right: 1px solid #d8e0e6;
}
.v-card.tiro-certeiro .users-row {
  background-color: #f3f6f7 !important;
  border-top: 1px solid #d8e0e6;
  border-left: 1px solid #d8e0e6;
  border-right: 1px solid #d8e0e6;
}
.v-card.selected .outcome-row,
.v-card.selected .users-row {
  background-color: #c6e5d1;
  border: 1px solid #5eaf72;
}
.v-card.selected .outcome-row {
  border-bottom: none;
}
.v-card.selected .outcome-row,
.v-card.selected .outcome-row div:nth-child(2),
.v-card.selected .users-row >>> .prognostic-number {
  color: #5eaf72 !important;
}
.v-card--link:focus:before {
  opacity: 0 !important;
}

.v-card.selected.result-success .outcome-row div:nth-child(2) {
  color: #26ab5e !important;
}
.v-card.selected.result-fail .outcome-row div:nth-child(2) {
  color: #f83030 !important;
}
.v-card.selected.result-success .users-row >>> .prognostic-number,
.v-card.selected.result-fail .users-row >>> .prognostic-number {
  color: #bcc5cc !important;
}
</style>

<script>
import Vue from "vue";
import UserAvatarList from "@/components/UserAvatarList.vue";

export default Vue.extend({
  name: "BetCard",
  components: {
    UserAvatarList,
  },
  props: {
    matchId: String,
    market: {},
    outcome: {},
    tmpOutcome: {},
    total: Number,
    updated: Boolean,
  },
  data: () => ({
    selectedClass: false,
  }),
  created() {
    if (this.outcome.users?.length > 0) {
      const userIds = [];
      this.outcome.users.forEach((user) => {
        if (user.uid == this.$store.state.user.uid) {
          this.selectMarket();
        } else if(!this.tmpOutcome.userIds.includes(user.uid)){
          userIds.push(user.uid);
        }
      });
      Vue.set(
        this.tmpOutcome,
        "userIds",
        this.tmpOutcome.userIds
          ? this.tmpOutcome.userIds.concat(userIds)
          : userIds
      );
    }
  },
  methods: {
    isTiroCerteiro() {
      return this.$route.path.includes("tiro-certeiro");
    },
    selectMarket() {
      if (this.isTiroCerteiro()) {
        const bet = {
          match: this.matchId,
          market: this.market.name,
          outcome: this.outcome.name,
        };
        this.selectedClass = true;
        this.$emit("clicked", bet);
      }
    },
    clearSelection() {
      this.selectedClass = false;
    },
  },
  computed: {
    percentage() {
      const percentage =
        this.total == 0 ? 0 : (this.outcome.users.length * 100) / this.total;
      return percentage.toFixed(2);
    },
    setClass() {
      let style = "";
      const outcome = this.outcome.result;

      if (this.isTiroCerteiro()) {
          style += "tiro-certeiro ";
        }

      if (this.selectedClass) {
        style += "selected ";
      }

      if (outcome) {
        if (outcome == "Certo") {
          style += "result-success";
        } else if (outcome == "Errado") {
          style += "result-fail ";
        }
      }
      
      

      return style;
    },
  },
});
</script>
